import { useEffect, useState } from "react";
import styled from "styled-components";
import { usePopup } from "../../context/PopupContext";
import { cartService } from "../../service/CartService";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import FilledButton from "../button/FilledButton";
import ErrorMessage from "../error/ErrorMessage";
import OutlinedPicker from "../picker/OutlinedPicker";
import H1 from "../typography/H1";
import H2 from "../typography/H2";
import ProductImageViewer from "./ProductImageViewer";
import ProductTabbedDescription from "./ProductTabbedDescription";
const Wrapper = styled.div``;
const Container = styled.div`
  margin: 5%;
  margin-bottom: 0px;
`;
const Flex = styled.div`
  display: flex;
  gap: 70px;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;
const Details = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const ProductTitle = styled.div`
  h1 {
    font-weight: 400;
    color: ${colors.textMuted};
    font-size: ${fontSize.l};
  }
  h2 {
    font-weight: 500;
    font-size: ${fontSize.xl};
  }
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Info = styled.div`
  text-transform: capitalize;
  b {
    font-size: ${fontSize.s};
    color: ${colors.textSecondary};
  }
`;
const SmallColumn = styled.div`
  width: fit-content;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  h3 {
    font-size: ${fontSize.m};
    font-weight: 500;
  }
`;
const ColorPicker = styled.div``;
const Picker = styled.div`
  margin: 10px 0px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;
const SizePicker = styled.div``;
const QuantityPicker = styled.div``;

function ProductDetails({ product }) {
  const [selectedSize, setSelectedSize] = useState();
  const [selectedColor, setSelectedColor] = useState();
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [errorMessage, setErrorMessage] = useState();
  const { showPopup } = usePopup();

  const handleAddToCart = async () => {
    if (!selectedColor) {
      setErrorMessage("You must select a color.");
    }
    if (!selectedSize) {
      setErrorMessage("You must select a size.");
    }
    if (selectedColor && selectedSize) {
      setErrorMessage(null);
      cartService
        .pushToCart({
          productId: product._id,
          color: selectedColor,
          size: selectedSize,
          quantity: selectedQuantity,
          price: selectedQuantity * product.price,
        })
        .then(() => {
          showPopup(
            `${product.name} has been added to your cart.`,
            "You can view your cart items in the cart page.",
          );
        });
    }
  };

  useEffect(() => {
    const refresh = () => {
      setSelectedColor();
      setSelectedQuantity(1);
      setSelectedSize();
      setErrorMessage();
    };
    refresh();
  }, [product]);

  return (
    product && (
      <Wrapper>
        <Container>
          <Flex>
            <ProductImageViewer images={product.images} />
            <Details>
              <Info>
                <b>Category:</b> {product?.category?.name.toUpperCase()}
              </Info>
              <ProductTitle>
                <H1>{product.name.toUpperCase()}</H1>
                <H2>Rs. {product.price * selectedQuantity}</H2>
              </ProductTitle>
              <SmallColumn>
                <ColorPicker>
                  <h3>Color</h3>
                  <Picker>
                    {product.colors &&
                      product.colors.map((color, key) => (
                        <OutlinedPicker
                          key={key}
                          text={color.name.toUpperCase()}
                          onClick={() => setSelectedColor(color.name)}
                          selected={selectedColor === color.name}
                        />
                      ))}
                  </Picker>
                </ColorPicker>
                <SizePicker>
                  <h3>Size</h3>
                  <Picker>
                    {product.sizes &&
                      product.sizes.map((size, key) => (
                        <OutlinedPicker
                          key={key}
                          text={size.size.toUpperCase()}
                          onClick={() => setSelectedSize(size.size)}
                          selected={selectedSize === size.size}
                        />
                      ))}
                  </Picker>
                </SizePicker>
                <QuantityPicker>
                  <h3>Quantity</h3>
                  <Picker>
                    <OutlinedPicker
                      text="-"
                      onClick={() => {
                        selectedQuantity > 1 &&
                          setSelectedQuantity(selectedQuantity - 1);
                      }}
                    />
                    <OutlinedPicker text={selectedQuantity} />
                    <OutlinedPicker
                      text="+"
                      onClick={() => {
                        selectedQuantity < 5 &&
                          setSelectedQuantity(selectedQuantity + 1);
                      }}
                    />
                  </Picker>
                </QuantityPicker>
                {errorMessage && <ErrorMessage text={errorMessage} />}
                <FilledButton
                  text={"ADD TO CART"}
                  onClick={() => {
                    handleAddToCart();
                  }}
                />
              </SmallColumn>
              <Info>
                {product.material && (
                  <>
                    <b>Fabric | </b>
                    {product.material}
                  </>
                )}
              </Info>
              {product.description && (
                <ProductTabbedDescription description={product.description} />
              )}
            </Details>
          </Flex>
        </Container>
      </Wrapper>
    )
  );
}

export default ProductDetails;
